import React from 'react';
import monsterNames from '../data/names';
import breeding from '../data/breeding';
import { MonsterHeaderRenderer } from '../components/MonsterHeaderRenderer';
import families from '../data/families';
import { get } from 'lodash';

const noNullMonsters = monsterNames.map((item, dex) => ({ dex, item })).filter(item => item.item !== null && !!breeding[item.dex]).map(item => item.dex);

export default class TeamSelection extends React.Component {
  state = { gender: 'female' };
  changeTeam = () => {
    const updatedTeam =  { male: [2], female: [1] };
    this.props.onChooseTeam(updatedTeam);
  }
  addMonster = (monster) => {
    const currentTeam = this.props.team;
    const currentList = currentTeam[this.state.gender];
    const updatedTeam = {
      ...currentTeam,
      [this.state.gender]: currentList.concat(monster),
    };

    this.props.onChooseTeam(updatedTeam);
  }
  removeMonster = (gender, dex) => {
    const currentTeam = this.props.team;
    const currentList = currentTeam[gender];
    currentList.splice(dex, 1);
    const updatedTeam = {
      ...currentTeam,
      [gender]: currentList,
    };

    this.props.onChooseTeam(updatedTeam);
  }

  renderMonsters() {
    const familyNames = Object.keys(families);

    return (
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {familyNames.map(family => {
          const monsters = families[family];
          return (
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', maxWidth: 200, margin: 10 }}>
              {monsters.map(monster => {
                return <MonsterHeaderRenderer onClick={() => this.addMonster(monster)} style={styles.monsterStyle} data={monster} />
              })}
            </div>
          );
        })}
      </div>
    );
  }
  renderTeam() {
    const team = get(this, ['props', 'team']) || {};
    // const { team = {} } = this.props;
    const { male = [], female = [] } = team;

    return (
      <div style={{ paddingTop: 30 }}>
        males
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {male.map((monster, dex) => {
            return <MonsterHeaderRenderer onClick={() => this.removeMonster('male', dex)} style={styles.monsterStyle} data={monster} />
          })}
        </div>
        females
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {female.map((monster, dex) => {
            return <MonsterHeaderRenderer onClick={() => this.removeMonster('female', dex)} style={styles.monsterStyle} data={monster} />
          })}
        </div>
      </div>
    )
  }
  render() {
    const { style, team } = this.props;

    return (
      <div style={style ? Object.assign({}, styles.container, style) : styles.container}>
        {this.renderTeam()}
        <div style={{ padding: 10, marginTop: 30 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: '100' }}>Add A New Monster</div>
            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 30 }}>
              <div style={{ padding: 5, cursor: 'pointer' }} onClick={() => this.setState({ gender: 'male' })}>Male <input checked={this.state.gender === 'male'} type="radio" /></div>
              <div style={{ padding: 5, cursor: 'pointer' }} onClick={() => this.setState({ gender: 'female' })}>Female <input checked={this.state.gender === 'female'} type="radio" /></div>
            </div>
          </div>
          {this.renderMonsters()}
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    padding: 5,
    overflow: 'auto',
  },
  monsterStyle: {
    width: 65,
    height: 56,
    cursor: 'pointer',
  }
};
